'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _zoroClickstat = require('@alife/zoro-clickstat');

var _zoroClickstat2 = _interopRequireDefault(_zoroClickstat);

var _i18n = require('../i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Password = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Password, _Component);

    function Password(props) {
        (0, _classCallCheck3.default)(this, Password);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Password.__proto__ || Object.getPrototypeOf(Password)).call(this, props));

        _this.checkPwd = false;
        _this.buyerRegister = 'anything';
        _this.phoneRegisterAction = 'buyerJoin/phone_register_action';

        _this.checkPassword = function (password) {
            var r = /^[\w]{6,20}$/;
            if (password.length < 6 || password.length > 20) {
                return false;
            } else if (r.test(password)) {
                // 手机注册密码前端校验通过
                _this.clickDot({
                    buttonType: 'register_phone_do_savepassword',
                    objectType: 'input_box'
                });
                return true;
            } else {
                return false;
            }
        };

        _this.togglePassword = function () {
            _this.setState(function (state) {
                return {
                    showPassword: !state.showPassword
                };
            });
        };

        _this.state = {
            showPassword: false, // 显示密码
            isShowPasswordTip: false, // 是否展示密码错误提示
            showPasswordTip: _i18n2.default.INVALID_PHONE_PASSWORD, // 显示密码错误提示
            isShowPwdText: true, // 显示输入密码提示
            pwdError: '',
            passwordValue: ''
        };
        props.showViaEmail(false);
        props.batmanNav(true);
        props.showAgreement(false);
        props.showSNS(false);
        _this.onPhoneBlur = _this.onPhoneBlur.bind(_this);
        _this.onPasswordChange = _this.onPasswordChange.bind(_this);
        _this.onPhoneRegister = _this.onPhoneRegister.bind(_this);
        return _this;
    } // 前端校验密码是否符合

    // event_submit_do_phone_register

    (0, _createClass3.default)(Password, [{
        key: 'onPasswordChange',
        // action

        value: function onPasswordChange(e) {
            this.setState({
                passwordValue: e.target.value
            });
        }
    }, {
        key: 'onPhoneBlur',
        value: function onPhoneBlur() {
            // 手机注册密码点击打点
            this.clickDot({
                buttonType: 'password_phone',
                objectType: 'input_box'
            });
            var passwordValue = this.state.passwordValue;

            var stateObj = {};
            if (this.checkPassword(passwordValue)) {
                stateObj = {
                    isShowPwdText: true,
                    pwdError: '',
                    isShowPasswordTip: false
                };
                this.checkPwd = true;
            } else {
                stateObj = {
                    isShowPwdText: false,
                    pwdError: 'input-error',
                    isShowPasswordTip: true
                };
                this.checkPwd = false;
            }
            this.setState(stateObj);
        }

        // 校验注册手机号密码


        // 隐藏和显示密码框

    }, {
        key: 'getCountry',


        // 选取country对应的国家
        value: function getCountry() {
            if (this.props.countryCodeFormat == 7) {
                return 'RU';
            } else if (this.props.countryCodeFormat == 966) {
                return 'SA';
            } else if (this.props.countryCodeFormat == 971) {
                return 'AE';
            }
        }
    }, {
        key: 'onPhoneRegister',
        value: function onPhoneRegister() {
            var _this2 = this;

            this.props.toggleMask(true);
            if (!this.checkPwd) {
                this.props.toggleMask(false);
                return;
            }
            var postParams = {
                action: this.phoneRegisterAction,
                registerFrom: this.props.registerFrom,
                event_submit_do_phone_register: this.buyerRegister,
                countryCode: this.getCountry(),
                cellPhone: this.props.cellPhone,
                password: this.state.passwordValue,
                allowEDM: this.props.allowEDM,
                t: Math.random(),
                _csi_: this.props.sessionId
            };
            this.props.getBeginSendPostTime(new Date());
            (0, _util.sendPost)(this.props.actionUrl, postParams, this.props.ncData, this.props.nCf, this.props.cellPhone).then(function (returnObj) {
                if (typeof returnObj === 'undefined') {
                    _this2.props.toggleMask(false);
                    _this2.setState({
                        isShowPwdText: false,
                        pwdError: 'input-error',
                        isShowPasswordTip: true,
                        showPasswordTip: _i18n2.default.UNAVIALABLE_SERVICE
                    });
                    return;
                }
                if (returnObj.result === true) {
                    _this2.props.freeLogin(returnObj, _this2.props.cellPhone, 'phone');
                } else {
                    _this2.props.toggleMask(false);
                    _this2.setState({
                        isShowPwdText: false,
                        pwdError: 'input-error',
                        isShowPasswordTip: true,
                        showPasswordTip: returnObj.codeInfo
                    });

                    if (returnObj.code === 150 || returnObj.code === 151) {
                        // 手机注册密码为空点击打点
                        _this2.clickDot({
                            buttonType: 'password_empty_error',
                            objectType: 'input_box'
                        });
                    } else if (returnObj.code === 153) {
                        // 手机注册密码格式错误点击打点
                        _this2.clickDot({
                            buttonType: 'password_incorrect_error',
                            objectType: 'input_box'
                        });
                    } else {
                        // 手机注册失败其他原因
                        _this2.clickDot({
                            buttonType: 'register_phone_fail_others',
                            objectType: 'input_box'
                        });
                    }

                    if (_util.isMobile && _this2.props.phoneNc) {
                        _this2.props.phoneNc.reset();
                    } else if (!_util.isMobile && _this2.props.phoneNc) {
                        _this2.props.phoneNc.reload();
                    }
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var togglePasswordClass = (0, _classnames2.default)('toggle-password', {
                'password-show': this.state.showPassword,
                'password-hide': !this.state.showPassword
            });
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'h2',
                    { className: 'last-title' },
                    _i18n2.default.LAST_STEP
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'password-desc' },
                    _i18n2.default.SET_SIGN_IN_PASSWORD
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'input-box' },
                    _react2.default.createElement('input', { type: 'text', className: 'input-phone-last', name: '', placeholder: this.props.countryCode + ' ' + this.props.phoneValue, disabled: 'disabled' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'input-box' },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('input', {
                            value: this.state.passwordValue,
                            className: 'input-password ' + this.state.pwdError,
                            placeholder: _i18n2.default.PASSWORD,
                            type: this.state.showPassword ? 'text' : 'password',
                            onBlur: this.onPhoneBlur,
                            onChange: this.onPasswordChange
                        }),
                        _react2.default.createElement('span', { className: togglePasswordClass, onClick: this.togglePassword })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'error-tip', style: { display: this.state.isShowPasswordTip ? 'block' : 'none' } },
                        this.state.showPasswordTip
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'password-text-tip', style: { display: this.state.isShowPwdText ? 'block' : 'none' } },
                        _i18n2.default.INVALID_PASSWORD
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'edm-box' },
                    this.props.isShowEDM ? _react2.default.createElement('input', { checked: this.props.allowEDM, onChange: function onChange(param) {
                            _this3.props.handleChangeEDM(param);
                        }, type: 'checkbox', id: 'register-edm', name: 'edm-checkbox' }) : '',
                    this.props.isShowEDM ? _react2.default.createElement(
                        'span',
                        null,
                        this.props.textEDM
                    ) : ''
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-box' },
                    _react2.default.createElement(
                        'a',
                        { className: 'submit submit-password', onClick: this.onPhoneRegister },
                        _i18n2.default.SAVE_PASSWORD
                    )
                )
            );
        }

        // 曝光打点

    }, {
        key: 'ctrDot',
        value: function ctrDot(arg) {
            _zoroClickstat2.default.ctr({
                expType: arg.expType
            });
        }

        // 点击打点

    }, {
        key: 'clickDot',
        value: function clickDot(arg) {
            _zoroClickstat2.default.buttonClick({
                buttonType: arg.buttonType,
                objectType: arg.objectType
            });
        }
    }]);
    return Password;
}(_react.Component), _class.propTypes = {
    showViaEmail: _propTypes2.default.func,
    batmanNav: _propTypes2.default.func,
    showAgreement: _propTypes2.default.func,
    showSNS: _propTypes2.default.func,
    countryCodeFormat: _propTypes2.default.string,
    cellPhone: _propTypes2.default.string,
    registerFrom: _propTypes2.default.string,
    toggleMask: _propTypes2.default.func,
    nCf: _propTypes2.default.object,
    sessionId: _propTypes2.default.string,
    actionUrl: _propTypes2.default.string,
    ncData: _propTypes2.default.object,
    freeLogin: _propTypes2.default.func,
    countryCode: _propTypes2.default.string,
    phoneValue: _propTypes2.default.string,
    phoneNc: _propTypes2.default.object,
    getBeginSendPostTime: _propTypes2.default.func
}, _temp);
exports.default = Password;